// Cart-Store (Zustand) mit LocalStorage-Persist je User.

import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface CartItem {
  product_id: string;
  qty: number;
  unit_price_cents: number; // Snapshot beim Hinzufügen
  name: string;             // Snapshot
  unit: string;             // Snapshot
}

interface CartState {
  items: CartItem[];
  addItem: (i: CartItem) => void;
  setQty: (productId: string, qty: number) => void;
  removeItem: (productId: string) => void;
  clear: () => void;
  totalCents: () => number;
  count: () => number;
}

export const useCart = create<CartState>()(
  persist(
    (set, get) => ({
      items: [],
      addItem: (item) =>
        set((s) => {
          const existing = s.items.find((x) => x.product_id === item.product_id);
          if (existing) {
            return {
              items: s.items.map((x) =>
                x.product_id === item.product_id
                  ? { ...x, qty: x.qty + item.qty }
                  : x
              ),
            };
          }
          return { items: [...s.items, item] };
        }),
      setQty: (productId, qty) =>
        set((s) => ({
          items:
            qty <= 0
              ? s.items.filter((x) => x.product_id !== productId)
              : s.items.map((x) => (x.product_id === productId ? { ...x, qty } : x)),
        })),
      removeItem: (productId) =>
        set((s) => ({ items: s.items.filter((x) => x.product_id !== productId) })),
      clear: () => set({ items: [] }),
      totalCents: () =>
        get().items.reduce((acc, i) => acc + i.qty * i.unit_price_cents, 0),
      count: () => get().items.reduce((acc, i) => acc + i.qty, 0),
    }),
    { name: "hof-sirges-cart-v1" }
  )
);
